module.exports = __webpack_public_path__ + "media/entities/2102-366ed17d.png";